import { CloseRounded } from '@mui/icons-material'
import { Button, DialogContent, DialogTitle, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import { StyledTabs } from '../../../../../../shared/components/StyledTabs'
import TabPanel from '../../../../../../shared/components/TabPanel'
import { CustomDialogActions } from '../../../../../../shared/components/modals/CustomDialogActions'
import useTabState from '../../../../../../shared/hooks/useTabState'
import { StyledDialog } from '../../../../../../shared/styles/StyledDialog'
import { ROLES, UserModalProps } from '../../../../models/user'
import { useCreateInitialState } from '../../../hooks/modals/create/useCreateInitialState'
import { useCreateState } from '../../../hooks/modals/create/useCreateState'
import { useHandleCreateForm } from '../../../hooks/modals/create/useHandleCreateForm'
import { CenterTab } from './CenterTab'
import { ConfigTab } from './ConfigTab'
import { CustomTab } from './CustomTab'
import { GeneralClientTab } from './GeneralClientTab'
import { GeneralTab } from './GeneralTab'
import { HeaderInputs } from './HeaderInputs'
import { WorkTab } from './WorkTab'

function UserModal({ role_id, showBotton = true }: UserModalProps) {
  const { t } = useTranslation(['global'])

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { errorTab } = useSelector((state: IRootState) => state.validator)
  const { showForm } = useSelector((state: IRootState) => state.user)

  const { currentTab, setCurrentTab, a11yProps } = useTabState()
  const { user, handleInputChange, handleModalCreate, handleCloseModalUser, handleToggleMenusClick } = useCreateState(
    role_id,
    setCurrentTab
  )
  useCreateInitialState(user, setCurrentTab)
  const { handleSubmit } = useHandleCreateForm(user)

  return (
    <>
      {showBotton && (
        <Button id="btn-create-user" variant="outlined" color="secondary" onClick={() => handleModalCreate()}>
          {t('admin.people.create-user')}
        </Button>
      )}

      <StyledDialog
        open={showForm}
        onClose={handleCloseModalUser}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">
              {user.id !== 0 ? t('edit') : t('create')} {t('user')}
            </Typography>
            <Button onClick={handleCloseModalUser} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>

        <DialogContent sx={theme => ({ paddingBottom: theme.spacing(3), paddingTop: theme.spacing(2) })}>
          <form noValidate autoComplete="nope">
            <HeaderInputs user={user} handleInputChange={handleInputChange} />
            <Grid xs={12}>
              <StyledTabs value={currentTab} onChange={(_: any, value: number) => setCurrentTab(value)} aria-label="create user tabs">
                <CustomTab error={errorTab.general} label={t('general')} {...a11yProps(0)} display={user.role_id !== ROLES.client} />
                <CustomTab error={errorTab.work} label={t('admin.people.work')} {...a11yProps(1)} display={user.role_id !== ROLES.client} />
                <CustomTab error={errorTab.general} label={t('general')} {...a11yProps(2)} display={user.role_id === ROLES.client} />
                <CustomTab
                  error={errorTab.center}
                  label={t('admin.people.center')}
                  {...a11yProps(3)}
                  display={[ROLES.client, ROLES.trainer].includes(user.role_id)}
                />
                <CustomTab
                  error={errorTab.config}
                  label={t('admin.people.configuration')}
                  {...a11yProps(4)}
                  display={authUser.role_id !== ROLES.client}
                />
              </StyledTabs>
            </Grid>

            <TabPanel value={currentTab} index={0}>
              <GeneralTab user={user} handleInputChange={handleInputChange} />
            </TabPanel>
            <TabPanel value={currentTab} index={1}>
              <WorkTab user={user} handleInputChange={handleInputChange} />
            </TabPanel>
            <TabPanel value={currentTab} index={2}>
              <GeneralClientTab user={user} handleInputChange={handleInputChange} />
            </TabPanel>
            <TabPanel value={currentTab} index={3}>
              <CenterTab user={user} handleInputChange={handleInputChange} />
            </TabPanel>
            <TabPanel value={currentTab} index={4}>
              <ConfigTab user={user} handleInputChange={handleInputChange} handleToggleMenusClick={handleToggleMenusClick} />
            </TabPanel>
          </form>
        </DialogContent>
        <CustomDialogActions handleSubmit={handleSubmit} handleClose={handleCloseModalUser} />
      </StyledDialog>
    </>
  )
}

export default UserModal
